module.exports = __webpack_public_path__ + "img/weixin.211ea700.png";